import styled, { css } from "styled-components";
import { colors, font, radius, shadow } from "../../styles/theme/tokens";

export const MaterialsWrapper = styled.div`
   display: flex;
   flex-direction: column;
   gap: 32px;
   max-width: 1080px;
`

export const TopicWrapper = styled.section`
   display: flex;
   flex-direction: column;
   gap: 14px;
`

export const TopicName = styled.h2`
   display: flex;
   align-items: center;
   gap: 10px;
   font-family: ${font.text};
   font-size: 20px;
   font-weight: 800;
   color: ${colors.ink};

   &::before {
      content: '';
      width: 6px;
      height: 22px;
      border-radius: ${radius.pill};
      background: ${colors.brand};
   }
`

export const List = styled.ul`
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
   gap: 12px;
`

export const Item = styled.li`
   position: relative;
   display: flex;
   flex-direction: column;
   gap: 6px;
   border-radius: ${radius.lg};
   background: ${colors.surface};
   border: 1px solid ${colors.line};
   box-shadow: ${shadow.card};
   overflow: hidden;
   cursor: pointer;
   transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;

   &:hover {
      transform: translateY(-2px);
      box-shadow: ${shadow.raised};
      border-color: ${colors.brand};
   }

   ${(props) => props.isRevision && css`
      background: ${colors.amberSoft};
      border-color: #F6DDA6;

      &:hover {
         border-color: ${colors.amber};
      }
   `}
`

export const LessonName = styled.a`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 8px;
   width: 100%;
   padding: 16px;
   font-family: ${font.text};
   font-size: 16px;
   font-weight: 800;
   color: ${colors.ink};
   text-decoration: none;

   svg {
      flex-shrink: 0;
      color: ${colors.muted};
      transition: color 0.15s ease;
   }

   &:hover svg {
      color: ${colors.brand};
   }
`

export const Answers = styled.a`
   align-self: flex-start;
   margin: -8px 18px 14px;
   padding: 3px 10px;
   border-radius: ${radius.pill};
   font-family: ${font.text};
   font-size: 12px;
   font-weight: 700;
   color: ${colors.brandDeep};
   background: ${colors.brandSoft};
   text-decoration: none;
`

// Картка «Додаткові матеріали» внизу сторінки учня
export const Extra = styled.button`
   display: flex;
   align-items: center;
   gap: 16px;
   width: 100%;
   max-width: 520px;
   padding: 18px 20px;
   border-radius: ${radius.lg};
   text-align: left;
   color: #FFFFFF;
   background: linear-gradient(135deg, ${colors.brandDark} 0%, ${colors.brandDeep} 70%, ${colors.brand} 100%);
   box-shadow: ${shadow.raised};
   cursor: pointer;
   transition: transform 0.15s ease;

   &:hover {
      transform: translateY(-2px);
   }
`

export const ExtraIcon = styled.span`
   display: grid;
   place-items: center;
   width: 46px;
   height: 46px;
   flex-shrink: 0;
   border-radius: ${radius.md};
   background: rgba(255, 255, 255, 0.16);
`

export const ExtraText = styled.span`
   flex: 1;
   font-family: ${font.text};

   b {
      display: block;
      font-size: 17px;
      font-weight: 800;
   }

   small {
      font-size: 13px;
      font-weight: 500;
      opacity: 0.8;
   }
`

export const BtnWrapper = styled.div`
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   gap: 12px;
`

export const Btn = styled.button`
   display: grid;
   place-items: center;
   width: 40px;
   height: 40px;
   border-radius: ${radius.pill};
   font-family: ${font.text};
   font-size: 22px;
   font-weight: 700;
   line-height: 1;
   color: ${(props) => (props.isOpen ? colors.amberDeep : colors.brandDeep)};
   background: ${(props) => (props.isOpen ? colors.amberSoft : colors.brandSoft)};
   cursor: pointer;
`

export const TopicBtn = styled.button`
   padding: 10px 16px;
   border-radius: ${radius.md};
   font-family: ${font.text};
   font-size: 14px;
   font-weight: 700;
   color: ${colors.brandDeep};
   background: ${colors.surface};
   border: 1.5px dashed ${colors.brand};
   cursor: pointer;
`

export const Draft = styled.span`
  align-self: flex-start;
  margin: -8px 16px 14px;
  padding: 2px 10px;
  border-radius: ${radius.pill};
  font-size: 12px;
  font-weight: 700;
  color: ${colors.ink};
  background: ${colors.amberSoft};
`;
